import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

interface BackButtonProps {
  label?: string;
  to?: string;
}

export const BackButton = ({ label = "Back", to }: BackButtonProps) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleBack = () => {
    if (to) {
      navigate(to);
    } else if (user) {
      // If authenticated, go to home page
      navigate('/home');
    } else {
      // If not authenticated, go to landing page
      navigate('/');
    }
  };

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={handleBack}
      className="mb-4"
    >
      <ArrowLeft className="mr-2 h-4 w-4" />
      {label}
    </Button>
  );
};
